// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"c7102f9b","365":"25514403","787":"afcd5720"}[chunkId] + ".chunk.js";
};